import { Link } from '@tanstack/react-router'
import {
  DownloadIcon,
  FileTextIcon,
  ListIcon,
  MessageSquareIcon,
} from 'lucide-react'

import { Button } from '@/components/ui'
import { downloadRowsCsv } from '@/components/ui/table/exportRows'
import { useProject, useTransactions } from '@/modules/projects/hooks'
import { getProjectPath } from '@/utils'
import { transactionsExport } from '../tables/transactions/transactionsExport'
import { askAboutCase } from './askAboutCase'

export const TrialNextSteps = ({ slug }: { slug: string }) => {
  const isChatEnabled = Boolean(useProject()?.isAiFeaturesEnabled)
  const projectPath = getProjectPath({ slug })
  const transactions = useTransactions()

  const exportTransactions = () =>
    downloadRowsCsv(
      transactionsExport(transactions),
      `${slug}-transactions.csv`,
    )

  return (
    <div className="flex flex-wrap items-center gap-2">
      {isChatEnabled && (
        <Button data-tour="ask-question" onClick={() => askAboutCase(slug)}>
          <MessageSquareIcon />
          Ask a question
        </Button>
      )}
      <Button theme="outline" asChild>
        <Link to={`${projectPath}/transactions`}>
          <ListIcon />
          View transactions
        </Link>
      </Button>
      <Button theme="outline" asChild>
        <Link to={`${projectPath}/analysis`}>
          <FileTextIcon />
          See a sample report
        </Link>
      </Button>
      <Button
        theme="outline"
        onClick={exportTransactions}
        disabled={transactions.length === 0}
      >
        <DownloadIcon />
        Export transactions (CSV)
      </Button>
    </div>
  )
}
